import Vue from 'vue'

interface NamedExercise {
  number: number | string
  name?: string
  getName? (): string
}

export function exerciseName (vm: Vue, exercise?: NamedExercise | null): string {
  if (!exercise) return ''
  const key = `EXERCISE[${exercise.number}].NAME`
  if (vm.$te(key)) return vm.$t(key) as string
  return (exercise.getName ? exercise.getName() : exercise.name) || ''
}
